<template>
  <div class="layout-wrapper">
    <div class="content">
      <Navigation
        v-if="$auth.check()"
        class="navigation bg-white z-2 top-0 border-bottom-1 surface-border p-2"
      />
      <RouterView />
    </div>
    <Footer class="footer" />
  </div>
</template>

<script>
import Navigation from "@/components/Navigation"
import Footer from "@/components/Footer"

export default {
  components: { Navigation, Footer }
}
</script>

<style scoped lang="scss">
.layout-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.content {
  flex: 1 0 auto;
}
.footer {
  flex-shrink: 0;
}

.navigation {
  position: sticky;
}
</style>
